module.exports = __webpack_public_path__ + "img/微信图片_20211103160556.9608d1e4.png";